import { IUser } from './user'
export type ITypeAuth = 'EMAIL' | 'SMS'

export interface IUserContactData {
  username: string
  firstName: string
  lastName: string
  email: string
}

export interface ISart {
  data: string
  type: ITypeAuth
}

export interface SingupErrors {
  email?: boolean
  username?: boolean
}

export interface SignupState {
  email: string
  phone: string
  loading?: boolean
  error?: string
  step: SignupSteps
  codeSent?: boolean
  validatingExistingUsername?: boolean
  validatingExistingEmail?: boolean
  discordUrl?: string
  showReturnedUserModal?: boolean
  singupErrors?: SingupErrors
}

export interface SignupContextProps extends SignupState {
  resetProcess: () => void
  setUserContact: (data: IUserContactData, avatar?: File) => void
  validateExistingUsername: (value: string) => Promise<void | boolean>
  continueStep: (u: IUser) => void
  backStep: () => void
  finishRegister: (user?: IUser) => void
  skipOnboarding: () => void
  continueOnboarding: () => void
  closeReturnedUserModal: () => void
  addTags: (user: IUser) => void
  validateExistingEmail: (value: string) => void
}

export enum SignupActionTypes {
  SET_ERROR = '[Signup] Set Error',
  SET_LOADER = '[Signup] Set Loader',
  SET_STEP = '[Signup] Set Step',
  SET_CODE_SENT = '[Signup] Set Code Sent',
  SET_EMAIL = '[Signup] Set Email',
  SET_PHONE = '[Signup] Set Phone',
  SET_VALIDATING_USERNAME = '[Signup] Set Validating Username',
  SET_VALIDATING_EMAIL = '[Signup] Set Validating Email',
  SET_DISCORD_INVITE = '[Signup] Set Discord Invite',
  SET_SHOW_RETURNED_USER_MODAL = '[Signup] Set Show Returned User Modal',
  SET_SINGUP_ERRORS = '[Signup] Set Singup Errors',
}

export enum SignupSteps {
  INITIAL = 'INITIAL',
  AVATAR_STEP = 'AVATAR_STEP',
  REQUEST_CODE = 'REQUEST_CODE',
  SEND_CODE = 'SEND_CODE',
  PHONE_NUMBER_STEP = 'PHONE_NUMBER_STEP',
  USER_INFO_FORM = 'USER_INFO_FORM',
  LOCATION_FORM = 'LOCATION_FORM',
  SOCIALS_FORM = 'SOCIALS_FORM',
  COMPLETE_PROFILE = 'COMPLETE_PROFILE',
  CREATOR_TYPE = 'CREATOR_TYPE',
  CONTENT_TYPE = 'CONTENT_TYPE',
  COLLAB_TYPE = 'COLLAB_TYPE',
  FINAL_STEP = 'FINAL_STEP',
}

export interface IValidateCodeRequestData {
  type: ITypeAuth
  otp: string
  data: string
}

export interface ITagProformated {
  label: string
  priority?: number
}

export interface AuthMiddlewareState {
  loading: boolean
  isAuthenticated: boolean
  wasValidated: boolean
  isComplete?: boolean
}

export enum AuthMiddlewareActionTypes {
  SET_LOADING = '[AuthMiddleware] Set Loading',
  SET_AUTHENTICATED = '[AuthMiddleware] Set Authenticated',
  SET_WAS_VALIDATED = '[AuthMiddleware] Set Was Validated',
  SET_IS_COMPLETE = '[AuthMiddleware] Set Is Complete',
}

export enum SignInSteps {
  INITIAL = 'INITIAL',
  SEND_CODE = 'SEND_CODE',
  FINAL_STEP = 'FINAL_STEP',
}

export interface SignInState {
  email?: string
  code?: string
  error?: string
  codeSent?: boolean
  loading?: boolean
  step: SignInSteps
}
export interface SignInContextProps extends SignInState {
  requestCode: (email: string) => void
  validateCode: (code: string) => void
  resendCode: () => void
}

export enum SignInActionTypes {
  SET_ERROR = '[SignIn] Set Error',
  SET_LOADER = '[SignIn] Set Loader',
  SET_EMAIL = '[SignIn] Set Email',
  SET_CODE = '[SignIn] Set Code',
  SET_CODE_SENT = '[SignIn] Set Code Sent',
  SET_STEP = '[SignIn] Set Step',
}
